<template>
  <div class="conrainer">
      <BigScreenHead>
          <template v-slot:left >
              <div class="head-left">
                  <i class="iconfont1" :title="baseInfo.onlineState==1?'在线':(baseInfo.onlineState==0?'离线':'信号差')" :style="{cursor: 'default', color:baseInfo.onlineState==1?'#40b337':(baseInfo.onlineState==0?'#bf0000':'#7194F3')}">&#xe618;</i>
                  <i class="el-icon-star-off" v-if="baseInfo.attention==0" title="未关注" @click="attentionDevice" style="color:#EDB941;font-size:27px;margin-right:15%;cursor:pointer"></i>
                  <i class="el-icon-star-on" v-if="baseInfo.attention==1" title="已关注" @click="attentionDevice" style="color:#EDB941;font-size:32px;margin-right:15%;cursor:pointer"></i>
                  <i v-if="user.systemRole==1 || user.systemRole==2 || user.systemRole==3" class="iconfont1" :title="baseInfo.lockState==0?'未锁机':'已锁机'" @click="lockDevice" :style="{color:baseInfo.lockState==0?'#40b337':'#bf0000'}">{{baseInfo.lockState==0?'&#xe625;':'&#xe615;'}}</i>
                  <i title="设备锁机记录" @click="getDeviceLockLog()" class="iconfont">&#xe63f;</i>
              </div>
          </template>
          <template v-slot:center >
              <div class="head-title">出厂编号：{{baseInfo.factorNo}}</div>
          </template>
      </BigScreenHead>
      <main>
          <div class="left">
              <div class="left-top">
                  <div class="item">
                      <div class="chart chart1"></div>
                      <div class="title">吊重（千克）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart2"></div>
                      <div class="title">力矩（吨·米）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart3"></div>
                      <div class="title">力矩比（%）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart4"></div>
                      <div class="title">回转（度）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart5"></div>
                      <div class="title">高度（米）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart6"></div>
                      <div class="title">幅度（米）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart7"></div>
                      <div class="title">风速（米/秒）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart8"></div>
                      <div class="title">水平角（度）</div>
                  </div>
                  <div class="item">
                      <div class="chart chart9"></div>
                      <div class="title">垂直角（度）</div>
                  </div>
              </div>
              <div class="left-center">
                  <div class="center-left">
                      <div class="title">实时运行数据生成动态</div>
                      <div class="videobox" style="width:99%">
                          <iframe :src="iframeSrc" border="0" allow="geolocation; microphone; camera; midi; encrypted-media;"></iframe>
                      </div>
                  </div>
                  <div class="center-right">
                      <div class="title videoTitle">
                            <span v-if='videoFlag'>实时监控</span>
                          </div>
                      <div class="videobox" style="width:99%;margin-left:1%">
                          <div v-if="videoFlag" class="zanwu">
                              该设备未加装任何摄像头，如果需要，请拨打400-8521-747购置安装。
                          </div>
                          <iframe :src="videoSrc" v-if='!videoFlag' allow="geolocation; microphone; camera; midi; encrypted-media;"></iframe>
                      </div>
                  </div>
              </div>
              <div class="left-bottom" v-if="TowerInfoType">
                  <div class="title" style="position: relative;">
                      <span>设备核心参数及运行数据</span>
                      <button class="top-btn" style="width:4.2rem;right: 0rem;" @click="TowerInfoType = false">变频器数据</button>   
                  </div>
                  <ul class="bottom-ul">
                      <li><i class="iconfont2">&#xe619;</i>设备类型：塔机</li>
                      <li><i class="iconfont2">&#xe619;</i>塔机类型：{{hexinInfo.Type==1?'平头':'其他' || 0}}</li>
                      <li><i class="iconfont2">&#xe619;</i>倍率：{{hexinInfo.RopeRate || 0}}（倍）</li>
                      <li><i class="iconfont2">&#xe619;</i>相对坐标X：{{hexinInfo.RelatedX || 0}}</li>
                      <li><i class="iconfont2">&#xe619;</i>相对坐标Y：{{hexinInfo.RelatedY || 0}}</li>
                      <li><i class="iconfont2">&#xe619;</i>首节高度：{{hexinInfo.FirstHeight || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>塔节高度：{{hexinInfo.NodeHeight || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>节数：{{hexinInfo.NodeCount || 0}}（节）</li>
                      <li><i class="iconfont2">&#xe619;</i>塔身高度：{{hexinInfo.BodyHeight || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>塔帽高度：{{hexinInfo.Type==1?'0': hexinInfo.NodeHeight || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>前臂长度：{{hexinInfo.ForeLength || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>后臂长度：{{hexinInfo.RearLength || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>左转限位：{{hexinInfo.TurnLeftLimit || 0}}（度）</li>
                      <li><i class="iconfont2">&#xe619;</i>右转限位：{{hexinInfo.TurnRightLimit || 0}}（度）</li>
                      <li><i class="iconfont2">&#xe619;</i>近限位：{{hexinInfo.NearLimit || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>远限位：{{hexinInfo.ForeLength - hexinInfo.FarLimit || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>高限位：{{hexinInfo.BodyHeight - hexinInfo.HighLimit || 0}}（米）</li>
                      <li><i class="iconfont2">&#xe619;</i>力矩限位：{{hexinInfo.TorqueLimit || 0}}（%）</li>
                  </ul>
              </div>
              <div class="left-bottom" v-else>
                  <div class="title" style="position: relative;">
                      <span>设备变频器数据</span>
                      <button class="top-btn" style="width:4.2rem;right: 0rem;" @click="TowerInfoType = true">运行数据</button>   
                  </div>
                  <ul class="bottom-ul">
                        <div class="deviceBPQData">
                            <p class="headBPQ">起升状态数据</p>
                            <li><i class="iconfont2">&#xe619;</i>运行状态：{{towerBPQInfoData.Hoisting.Run}}</li>
                            <li><i class="iconfont2">&#xe619;</i>运行频率：{{towerBPQInfoData.Hoisting.Frequency}}</li>
                            <li><i class="iconfont2">&#xe619;</i>电机转速：{{towerBPQInfoData.Hoisting.MotorSpeed}}</li>
                            <li><i class="iconfont2">&#xe619;</i>母线电压：{{towerBPQInfoData.Hoisting.BusVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电压：{{towerBPQInfoData.Hoisting.OutpuVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电流：{{towerBPQInfoData.Hoisting.OutputCurrent}}</li>
                            <li><i class="iconfont2">&#xe619;</i>设备温度：{{towerBPQInfoData.Hoisting.Temperature}}</li>
                            <li><i class="iconfont2">&#xe619;</i>刹车检查：{{towerBPQInfoData.Hoisting.HoistigBrakeTorque}}</li>
                        </div>
                        <div class="deviceBPQData">
                            <p class="headBPQ">回转状态数据</p>
                            <li><i class="iconfont2">&#xe619;</i>运行状态：{{towerBPQInfoData.Slewing.Run}}</li>
                            <li><i class="iconfont2">&#xe619;</i>运行频率：{{towerBPQInfoData.Slewing.Frequency}}</li>
                            <li><i class="iconfont2">&#xe619;</i>电机转速：{{towerBPQInfoData.Slewing.MotorSpeed}}</li>
                            <li><i class="iconfont2">&#xe619;</i>母线电压：{{towerBPQInfoData.Slewing.BusVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电压：{{towerBPQInfoData.Slewing.OutpuVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电流：{{towerBPQInfoData.Slewing.OutputCurrent}}</li>
                            <li><i class="iconfont2">&#xe619;</i>设备温度：{{towerBPQInfoData.Slewing.Temperature}}</li>
                            <li><i class="iconfont2">&#xe619;</i>刹车检查：{{towerBPQInfoData.Slewing.HoistigBrakeTorque}}</li>
                        </div>
                        <div class="deviceBPQData">
                            <p class="headBPQ">变幅状态数据</p>
                            <li><i class="iconfont2">&#xe619;</i>运行状态：{{towerBPQInfoData.Derricking.Run}}</li>
                            <li><i class="iconfont2">&#xe619;</i>运行频率：{{towerBPQInfoData.Derricking.Frequency}}</li>
                            <li><i class="iconfont2">&#xe619;</i>电机转速：{{towerBPQInfoData.Derricking.MotorSpeed}}</li>
                            <li><i class="iconfont2">&#xe619;</i>母线电压：{{towerBPQInfoData.Derricking.BusVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电压：{{towerBPQInfoData.Derricking.OutpuVoltage}}</li>
                            <li><i class="iconfont2">&#xe619;</i>输出电流：{{towerBPQInfoData.Derricking.OutputCurrent}}</li>
                            <li><i class="iconfont2">&#xe619;</i>设备温度：{{towerBPQInfoData.Derricking.Temperature}}</li>
                            <li><i class="iconfont2">&#xe619;</i>刹车检查：{{towerBPQInfoData.Derricking.HoistigBrakeTorque}}</li>
                        </div>
                  </ul>
              </div>
          </div>
          <div class="right">
              <div class="title">设备基础信息</div>
              <ul class="right-ul">
                  <li><p>设备型号：</p><p v-overflow>{{baseInfo.machineNo}}</p></li>
                  <li><p>监控主机：</p><p v-overflow>{{baseInfo.imei}}</p></li>
                  <li><p>合同编号：</p><p v-overflow>{{baseInfo.contractNo}}</p></li>
                  <li><p>截面大小：</p><p v-overflow>{{baseInfo.section}}（米）</p></li>
                  <li><p>客户名称：</p><p v-overflow>{{baseInfo.customerName}}</p></li>
                  <li><p>销售公司：</p><p v-overflow>{{baseInfo.salesCompanyName}}</p></li>
                  <li><p>销售人员：</p><p v-overflow>{{baseInfo.salesPerson}}</p></li>
                  <li><p>发货地址：</p><p v-overflow>{{baseInfo.sendAddress}}</p></li>
                  <li><p>发货日期：</p><p v-overflow>{{baseInfo.sendDate | timeFomart}}</p></li>
              </ul>
              <div class="line"></div>
              <div class="title">今日告警与违章</div>
              <div class="alarmtitle">
                  <div class="iconbox">
                      <i class="iconfont2" style="font-size:22px">&#xe61d;</i>
                      告警：{{alarmCount}}
                  </div>
                  <div class="iconbox">
                      <i class="iconfont2" style="color: #EDB941;">&#xe61c;</i>
                      违章：{{violationCount}}
                  </div>
              </div>
              <div class="tablebox">
                  <table>
                      <tr>
                          <td>时间</td>
                          <td>异常类型</td>
                      </tr>
                      <tr v-for="(item,i) in abnormalList" :key="i">
                          <td>{{item.time}}</td>
                          <td :style="{color:item.color}" v-overflow>{{item.anomalousTypeName}}</td>
                      </tr>
                  </table>
              </div>
              <div class="page">
                  <div><i class="iconfont3" @click="prev">&#xe61f;</i></div>
                  <div style="margin-left:4%"><i class="iconfont3" @click="next">&#xe61e;</i></div>
              </div>
              <div class="line"></div>
              <div class="title" style="position: relative;">
                  <span>人脸识别</span>
                  <button class="top-btn" @click="Device15DayPersonLog()">详 情</button>                  
              </div>
              
              <dl>
                  <dt><img src="../assets/images/driver.webp" alt="加载中.."></dt>
                  <dd>
                      <div>
                          <p >驾驶人员：</p>
                          <p :title="person.name">{{person.name}}</p>
                      </div>
                      <div>
                          <p >身份证号：</p>
                          <p :title="person.id">{{person.id}}</p>
                      </div>
                      <div>
                          <p >识别时间：</p>
                          <p :title="person.time">{{person.time}}</p>
                      </div>
                  </dd>
              </dl>
          </div>

        <el-dialog title="锁机记录" :visible.sync="dialogTableVisible">
            <el-table :data="lockLogData" class="lockLogBox">
                <el-table-column property="creatUserName" label="操作人" ></el-table-column>
                <el-table-column property="lockHandle" label="操作类型">
                     <template slot-scope="scope">
                         <span v-if="scope.row.lockHandle == 1" style="color:#AD454E">锁机</span>
                         <span v-else style="color:#6D9E7B">解锁</span>
                    </template>
                </el-table-column>
                <el-table-column property="creatTime" label="锁机时间">
                     <template slot-scope="scope">
                         <span>{{scope.row.creatTime.replace('T',' ')}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="imei" label="设备编号"></el-table-column>
            </el-table>
            <div class="page">
                <div @click="lockPrev">上一页</div>
                <div style="margin:0 2%;">第{{lockOption.pageIndex}}页 共{{lockLogTotal}}条</div>
                <div @click="lockNext">下一页</div>
            </div>
        </el-dialog>

        <el-dialog title="人脸识别(15天内)" :visible.sync="dialogPersonVisible">
            <el-table :data="personLogData" class="personLogBox">
                <el-table-column property="time" label="识别时间"></el-table-column>
                <el-table-column property="name" label="姓名" ></el-table-column>
                <el-table-column property="id" label="身份证号"></el-table-column>
            </el-table>
        </el-dialog>

          <el-dialog width="25%" center :visible.sync="dialogVisible1" style="margin-top: 10%;">
            <template slot="title">
                <div style="color: #bf0000;font-size:20px">重要提示</div>
            </template>
            <div class="dialog">
                <div class="dialog-content" v-if="baseInfo.lockState==0"><span style="margin-left:35px;">该</span>操作将会锁止起重设备，会导致设备运行速度减半甚至关停，影响重大，请审慎操作！</div>
                <div class="dialog-content" v-if="baseInfo.lockState==1"><span style="margin-left:35px;">该</span>操作将会解锁起重设备，使设备恢复正常使用，请确认您的操作！</div>
                <div class="dialog-footer">
                    <button class="dialog-btn" :style="{background:baseInfo.lockState==0?'#bf0000':'#40b337'}" @click="lockConfirm">{{baseInfo.lockState==0?'确认锁机':'确认解锁'}}</button>
                    <button class="dialog-btn btn2" @click="dialogVisible1 = false">放弃操作</button>
                </div>
            </div>
        </el-dialog>

          <el-dialog width="25%" center :visible.sync="dialogVisible2" style="margin-top: 10%;">
            <template slot="title">
                <div style="color: #bf0000;font-size:20px">重要提示</div>
            </template>
            <div class="dialog">
                <div class="dialog-content" v-if="baseInfo.attention==0"><span style="margin-left:35px;">该</span>操作将会关注起重设备，被关注的设备将会展示在大屏“关注设备”中！</div>
                <div class="dialog-content" v-if="baseInfo.attention==1"><span style="margin-left:35px;">该</span>操作将会取消关注起重设备，被取消关注的设备将不再出现于大屏“关注设备”中！</div>
                <div class="dialog-footer">
                    <button class="dialog-btn" :style="{background:baseInfo.attention==0?'#40b337':'#bf0000'}" @click="attentionConfirm">{{baseInfo.attention==0?'确认关注':'确认取关'}}</button>
                    <button class="dialog-btn btn2" @click="dialogVisible2 = false">放弃操作</button>
                </div>
            </div>
        </el-dialog>
      </main>
  </div>
</template>

<script>
import { devicePei } from '../assets/js/echarts'
export default {
    data(){
        return{
            imei: '',
            baseInfo: {},
            hexinInfo: {},
            yibiaoTimer: 1, //仪表盘定时器
            iframeSrc: '',
            videoFlag: true,
            videoSrc: '',
            dialogVisible1: false,
            dialogVisible2: false,
            option: {
                imei: '',
                pageSize: 6,
                pageIndex: 1
            },
            abnormalList: [],
            abnormalListLength: 0,
            alarmCount: 0,
            violationCount: 0,
            person:{
                name: '暂无',
                id: '暂无',
                time: ''
            },
            user:{},
            dialogTableVisible:false,
            lockLogData:[],
            lockLogTotal:0,
            dialogPersonVisible:false,
            personLogData:[],
            towerBPQData:{},
            towerBPQInfoData:{
                Hoisting:{
                    Run:"无",
                    Frequency:0,
                    MotorSpeed:0,
                    BusVoltage:0,
                    OutpuVoltage:0,
                    OutputCurrent:0,
                    Temperature:0,
                    HoistigBrakeTorque:"无"
                },
                Slewing:{
                    Run:"无",
                    Frequency:0,
                    MotorSpeed:0,
                    BusVoltage:0,
                    OutpuVoltage:0,
                    OutputCurrent:0,
                    Temperature:0,
                    HoistigBrakeTorque:"无"
                },
                Derricking:{
                    Run:"无",
                    Frequency:0,
                    MotorSpeed:0,
                    BusVoltage:0,
                    OutpuVoltage:0,
                    OutputCurrent:0,
                    Temperature:0,
                    HoistigBrakeTorque:"无"
                },
            },
            TowerInfoType:true,
            towerBPQobtain:true,
            lockOption:{
                imei: '',
                pageSize: 6,
                pageIndex: 1
            }

        }
    },
    methods:{
        //设备基础信息
        getDeviceBasicsInfo(option){
            this.$api.DeviceBasicsInfo(option).then(res=>{
                this.baseInfo = res.data.data;
            })
        },
        //设备实况状态
        getDeviceRealtimeInfo(option){
            this.$api.DeviceRealtimeInfo(option).then(res=>{
                var tempData = JSON.parse(res.data.data);
                var towerStatus = tempData.DeviceStatus;
                var divName = [{type:false}, {type:false}, {type:false}, {type:false}, {type:false}, {type:false}, {type:false}, {type:false},];
                if(towerStatus!=null){
                    towerStatus = towerStatus.substring(4, 6) == "00" ? towerStatus.substring(0, 4) + "0" + towerStatus.substring(6, 16) : towerStatus.substring(0, 4) + "1" + towerStatus.substring(6, 16);
                    towerStatus = towerStatus.substring(5, 7) == "00" ? towerStatus.substring(0, 5) + "0" + towerStatus.substring(7, 15) : towerStatus.substring(0, 5) + "1" + towerStatus.substring(7, 15);
                    towerStatus = towerStatus.substring(6, 8) == "00" ? towerStatus.substring(0, 6) + "0" + towerStatus.substring(8, 14) : towerStatus.substring(0, 6) + "1" + towerStatus.substring(8, 14);
                    for (var i = 0; i < 7; i++) {
                        if (towerStatus[i] == "1" || towerStatus[i] == "2") {
                            divName[i].type = true
                            if (i === 3) {
                                divName[7].type = true
                            }
                        } else {
                            divName[i].type = false
                            if (i === 3) {
                                divName[7].type = false
                            }
                        }
                    }
                }
                devicePei({doc:'.chart1',data: tempData.Weight,status:divName[7].type});
                devicePei({doc:'.chart2',data: tempData.Torque,status:false});
                devicePei({doc:'.chart3',data: tempData.TorqueRate,status:divName[3].type});
                devicePei({doc:'.chart4',data: tempData.Rotation,status:divName[6].type});
                devicePei({doc:'.chart5',data: tempData.Height,status:divName[5].type});
                devicePei({doc:'.chart6',data: tempData.Range,status:divName[4].type});
                devicePei({doc:'.chart7',data: tempData.WindSpeed,status:divName[2].type});
                devicePei({doc:'.chart8',data: tempData.Pitch,status:divName[1].type});
                devicePei({doc:'.chart9',data: tempData.Roll,status:divName[0].type});
            })
        },
        //设备核心参数及运行数据
        getDeviceChartListInfo(option){
            this.$api.DeviceChartListInfo(option).then(res=>{
                this.hexinInfo = JSON.parse(res.data.data)
            })
        },
        //设备异常信息
        getDeviceAbnormalInfo(option){
            this.$api.DeviceAbnormalInfo(option).then(res=>{
                this.abnormalList = res.data.data.data;
                this.alarmCount = res.data.data.alarmCount;
                this.violationCount = res.data.data.violationCount;
                this.abnormalListLength = this.abnormalList.length;
                this.abnormalList.map(item=>{
                    item.time = item.time.slice(11,item.time.length);
                    if (item.anomalousTypeName.substring(item.anomalousTypeName.length - 2, item.anomalousTypeName.length) == '报警') {
                        item.color = '#bf0000';
                    }
                    if (item.anomalousTypeName.substring(item.anomalousTypeName.length - 2, item.anomalousTypeName.length) == '违章') {
                        item.color = '#edb941'
                    }
                })
                if(this.abnormalList.length < 6){
                    for(let i=this.abnormalList.length; i<6; i++){
                        this.abnormalList.push({
                            time: '',
                            anomalousTypeName: '',
                        })
                    }
                }
            })
        },
        //设备视频
        getDeviceVideoInfo(option){
            this.$api.DeviceVideoInfo(option).then(res=>{
                var tempData = res.data.data
                if (tempData != null && tempData.length != 0) {
                    this.videoFlag = false;
                    //this.videoSrc = `https://oss.yfhuizhi.net:9001/DeviceImitate/Video?accesstoken=${tempData[0].accessToken}&url=${tempData[0].url}`;
                    this.videoSrc = `https://oss.yfhuizhi.net:9001/DeviceImitate/NewVideo?accesstoken=${tempData[0].accessToken}&url=${tempData[0].url}`;
                    tempData.map((item, i) => {
                        var div = document.querySelector('.videoTitle');
                        var btn = document.createElement('button');
                        btn.innerHTML = item.sceneNo;
                        btn.style.cssText = `background:#169bd5; color:white; border:none ;border-radius:3px; height:45%; min-width:50px; font-size:15px; margin-right:10px; padding: 0 6px; cursor:pointer;`;
                        div.appendChild(btn);
                        btn.addEventListener('click', () => {
                            //this.videoSrc = `https://oss.yfhuizhi.net:9001/DeviceImitate/Video?accesstoken=${item.accessToken}&url=${item.url}`;
                            this.videoSrc = `https://oss.yfhuizhi.net:9001/DeviceImitate/NewVideo?accesstoken=${item.accessToken}&url=${item.url}`;
                        })
                    })
                } else {
                    this.videoFlag = true;
                }
            })
        },
        //设备15天最后打卡人
        getDeviceLastPerson(option){
            this.$api.DeviceLastPerson({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    var persons = JSON.parse(res.data.data);
                    if (persons.length > 0)
                    {
                        this.person.name = persons[0].Name;
                        this.person.id = persons[0].ID;
                        this.person.time = persons[0].Time.replace(/-/g,'/').replace(/T/g,' ').substring(0,19);
                    }
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            })
        },
        //设备锁机记录
        getDeviceLockLog(){
            this.$api.DeviceLockHistoryPage(this.lockOption).then(res=>{
                this.lockLogData = res.data.data.data;
                this.lockLogTotal = res.data.data.total;
            })
            this.dialogTableVisible = true;
        },
        //设备人员打卡记录
        Device15DayPersonLog(){
            this.$api.Device15DayPerson({imei:this.imei}).then(res=>{
                this.personLogData = res.data.data;
            })
            this.dialogPersonVisible  = true;
        },
        //塔机变频数据
        TowerFrequencytory(){
            this.$api.TowerFrequencytory({imei:this.imei}).then(res=>{
                if(res.data.data!=null && res.data.data != ""){
                    var data = JSON.parse(res.data.data);
                    this.towerFrequencytoryData = data;

                    if(data.Data!=null && data.Data != ""){
                        var value = JSON.parse(data.Data);
                        if(value.Frequency != null && value.Frequency != "" )
                            this.towerBPQInfoData = value;
                    }
                }
            })
        },
        //实时模拟视频
        showMoniVideo() {
            this.$nextTick(() => {
                var moniDiv = document.querySelector(".videobox");
                var iframeH = moniDiv.offsetHeight;
                var iframeW = moniDiv.offsetWidth;
                this.iframeSrc = `https://oss.yfhuizhi.net:9001/DeviceImitate/Tower?imei=${this.imei}&height=${iframeH}&width=${iframeW}`;
            });
        },
        //锁机
        lockDevice(){
            this.dialogVisible1 = true
        },
        //关注设备
        attentionDevice(){
            this.dialogVisible2 = true
        },
        //上一页
        lockPrev(){
            if (this.lockOption.pageIndex <= 1) return;
            this.lockOption.pageIndex --;
            this.getDeviceLockLog();
        },
        //下一页
        lockNext(){
            if(this.lockLogTotal < this.lockOption.pageSize) return;
            this.lockOption.pageIndex ++;
            this.getDeviceLockLog();
        },
        //上一页
        prev(){
            if (this.option.pageIndex <= 1) return;
            this.option.pageIndex --;
            this.getDeviceAbnormalInfo(this.option);
        },
        //下一页
        next(){
            if(this.abnormalListLength < this.option.pageSize) return;
            this.option.pageIndex ++;
            this.getDeviceAbnormalInfo(this.option);
        },
        //锁机的确定按钮
        lockConfirm(){
            this.$api.DeviceLock({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'success'
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'error'
                    });
                }
                this.getDeviceBasicsInfo({imei:this.imei});
                this.dialogVisible1 = false;
            })
        },
        //关注的确定
        attentionConfirm(){
            this.$api.FocusImei({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'success'
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'error'
                    });
                }
               this.getDeviceBasicsInfo({imei:this.imei});
               this.dialogVisible2 = false;
            })
        },
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'))
        this.imei = this.$route.query.imei;
        this.option.imei = this.imei
        this.lockOption.imei = this.imei
    },
    mounted(){
        if (this.yibiaoTimer != null) {
            clearInterval(this.yibiaoTimer)
        }
        this.yibiaoTimer = setInterval(() => {
            this.getDeviceRealtimeInfo({imei:this.imei});
        }, 1000 * 3)
        this.showMoniVideo();
        this.getDeviceRealtimeInfo({imei:this.imei});
        this.getDeviceBasicsInfo({imei:this.imei});
        this.getDeviceChartListInfo({imei:this.imei});
        this.getDeviceAbnormalInfo(this.option);
        this.getDeviceVideoInfo({imei:this.imei});
        this.getDeviceLastPerson({imei:this.imei});
        this.TowerFrequencytory();
    },
    beforeDestroy() {
        clearInterval(this.yibiaoTimer)
    }
}
</script>

<style lang="scss" scoped>
.iconfont{
    font-family:"iconfont" !important;
    font-size: 26px;
    font-style: normal;
    color: #7194F3;
    cursor: pointer;
}
.iconfont1{
    font-family:"iconfont" !important;
    font-size: 26px;
    font-style: normal;
    color: #fff;
    cursor: pointer;
}
.iconfont2{
    font-family:"iconfont" !important;
    font-size: 1.25rem;
    font-style: normal;
    color: #EDB941;
    margin: 0 0.5rem;
    font-weight: normal;
}
.iconfont3{
    font-family:"iconfont" !important;
    font-style: normal;
    margin: 0 0.5rem;
    font-weight: normal;
}
iframe {
    border: none;
    width: 100%;
    height: 100%;
}
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}
.head-left{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 25%;
    height: 100%;
    margin-left: 2%;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 98%;
    display: flex;
    .left{
        flex: 1;
        margin-right: 0.625rem;
        display: flex;
        flex-direction: column;
    }
    .right{
        width: 17%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .line{
            background: #EDB941;
            height: 1px;
            width: 95%;
            margin: 0.8125rem auto;
        }
        .title{
            font-weight: bold;
            letter-spacing: 2px;
            font-size: 0.97rem;
            height: 4%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .right-ul{
            height: 30%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        li{
            display: flex;
            font-size: 0.9375rem;
            :nth-child(1){
                width: 27% !important;
            }
            :nth-child(2){
               flex: 1;
            }
            p{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .alarmtitle{
            display: flex;
            justify-content: space-around;
            padding: 5px 0;
            font-weight: bold;
            font-size: 0.9375rem;
            white-space: nowrap;
            :nth-child(1){color: #bf0000;}
            :nth-child(2){color: #EDB941;}
        }
        .tablebox{
            height: 31%;
            table{
                border-collapse: collapse;
                table-layout: fixed;
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 14px;
                td{
                    border: 1px solid #fff;
                    height: 14.2%;
                }
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 4%;
            font-size: 0.9375rem;
            & div{ cursor: pointer;}
            & div:active{ color: #EDB941;}
        }
        dl{
            flex: 1;
            display: flex;
            dt{
                width: 40%;
                padding: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    max-width: 100%;
                    max-height: 90%;
                }
            }
            dd{
                display: flex;
                flex: 1;
                justify-content: space-around;
                font-size: 0.875rem;
                flex-direction: column;
                padding: 10px 0;
            }
            div{
                display: flex;
                :nth-child(1){
                    width: 37%;
                    white-space: nowrap;
                }
                :nth-child(2){
                    flex: 1;
                }
            }
            p{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
.left-top{
    height: 20%;
    display: flex;
    .item{
        flex: 1;
        .chart{
            height: 87%;
        }
        .title{
            height: 13%;
            font-size: 0.96rem;
            font-weight: bold;
            text-align: center;
            letter-spacing: 2px;
        }
    }
}
.left-center{
    flex: 1;
    display: flex;
    .title{
        height: 10%;
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .center-left{
        flex: 1;
        flex-direction: column;
        display: flex;
    }
    .center-right{
        flex: 1;
        display: flex;
        flex-direction: column;
    }
    .videobox{
        flex: 1;
        background: #102037;
        display: flex;
        align-items: center;
        justify-content: center;
        .zanwu{
            width: 100%;
            text-align: center;
            color: #ccc;
            letter-spacing: 3px;
        }
    }
}
.left-bottom{
    height: 20%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.8%;
    .title{
        height: 32%;
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bottom-ul{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 16.6%;
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: bold;
            float: left;
        }
    }
    .deviceBPQData{
        margin-left: 3%;
        width: 30%;
        height: 100%;
        border: gray dashed 3px;
        padding: 10px;
        .headBPQ{
            text-align: center;
            font-weight: bold;
            letter-spacing: 2px;
            font-size: 0.97rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        li{
            width: 50%;
        }
    }
}
.dialog{
    .dialog-content{
        color: #000;
        line-height: 1.5625rem;
        width: 80%;
        margin-left: 10%;
        letter-spacing: 1px;
        flex: 1;
        font-size: 1.0625rem;
    }
    .dialog-footer{
        font-weight: 600;
        height: 40%;
        width: 80%;
        margin-left: 10%;
        margin-top: 5%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .dialog-btn{
            width: 29%;
            height: 1.9rem;
            color: #fff;
            background: #bf0000;
            line-height: 0;
            border-radius: 5px;
            cursor: pointer;
        }
        .btn2{
            background: #B3B3B3
        }
        .dialog-btn:active{background: rgba($color: #bf0000, $alpha: 0.9);}
        .btn2:active{background: rgba($color: #B3B3B3, $alpha: 0.9);}
    }
}
.top-btn{
    width: 3.75rem;
    height: 1.5rem;
    border-radius: 5px;
    color: #fff;
    background: #7194F3;
    cursor: pointer;
    padding: 0;
    line-height: 0;
    font-weight: bold;
    font-size: 0.75rem;
    position: absolute;   
    right: 0.4rem;
}
.top-btn:active{
        background: rgba($color: #7194F3, $alpha: 0.9);
}
.page{
    //border: 1px solid red;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 7%;
    font-weight:bold;
    font-size: 0.9375rem;
    & div{ cursor: pointer;}
    & div:active{ color: #EDB941;}
}
.lockLogBox{
    width: 100%;
    height: 340px;
}
.personLogBox{
    width: 100%;
    height: 340px;
    overflow-y:auto;
}
</style>